






































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NavigationButton extends Vue {
    @Prop({ default: false }) readonly fullWidthSubmenu!: boolean
    @Prop({ default: true }) readonly withSubmenu!: boolean
    @Prop({ default: null }) readonly route!: { name: string }
    @Prop({ default: null }) readonly event!: () => {}

    triggerEvent() {
        if (this.event === null) {
            return
        }

        this.event()
    }
}
